<div class="hero-suggestions">
    <div class="hero-suggestions__label">
        <span class="hero-suggestions__line"></span>
        <span class="hero-suggestions__text">Try our sample questions</span>
        <span class="hero-suggestions__line"></span>
    </div>
    <div class="hero-suggestions__content">
        @for(question of suggestedQuestions || []; track $index){
        <button
            pButton
            type="button"
            class="p-button-outlined"
            [pTooltip]="question"
            tooltipPosition="top"
            showDelay="500"
            hideDelay="100"
            (click)="handleClick(question)"
        >
            {{ question }}
        </button>
        }
    </div>
</div>
